import { useEffect, useState } from 'react'

interface CountdownSliderProps {
  timeoutInMs: number
}

export const CountdownSlider = ({ timeoutInMs }: CountdownSliderProps) => {
  const [timeLeft, setTimeLeft] = useState(timeoutInMs)

  useEffect(() => {
    if (!timeoutInMs) return

    setTimeLeft(timeoutInMs)
    const interval = setInterval(() => {
      setTimeLeft((prev: number) => {
        const newTimeLeft = Math.max(prev - 1000, 0)
        if (newTimeLeft <= 0) clearInterval(interval)
        return newTimeLeft
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [timeoutInMs])

  return (
    <div className="w-full bg-muted h-[3px]">
      <div
        className="bg-status-success h-full ease-linear transition-all duration-1000"
        style={{ width: `${(timeLeft / timeoutInMs) * 100}%` }}
      />
    </div>
  )
}
